import { Link } from "react-router-dom";

function LoggedOut() {

    return (
        <div className="py-10 text-center m-auto">
            <div className="mx-auto">
                <h1 className="text-3xl font-bold leading-tight text-gray-900">
                    Olet nyt kirjautunut ulos.
                </h1>
                <p className="my-5">Paina tästä, jos haluat kirjautua takaisin sisään.</p>
            </div>
            <div className="flex-grow flex">
                <div className="mx-auto m-5">
                    <Link to="/login" className="group relative w-full flex justify-center py-2 px-4 border border-transparent text-sm font-medium rounded-md text-white bg-teal-600 hover:bg-teal-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-teal-500">Kirjaudu sisään</Link>
                </div>
            </div>
        </div>
    )
}


export default LoggedOut;